import {useMutation} from "@tanstack/react-query";
import {AxiosError} from "axios";
import {manualSyncAllApi} from "../../../../api/code/CodeApi";
import {useModal} from "../../../../hooks";

export const useManualSyncAll = () => {

    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: () => manualSyncAllApi(),
        onSuccess: () => {
            handleModal({
                isOpen: true,
                contents: "동기화 되었습니다.",
                type: "alert",
                closeAction: () => window.location.reload()
            });
        },
        onError: (error: AxiosError<{ msg?: string }>) => {
            if (error?.response?.data?.msg) {
                handleModal({
                    isOpen: true,
                    contents: error?.response?.data?.msg,
                    type: "alert",
                });
            }
        },
    });

    return {mutate};
};
